<template>
    <div class="wh100">
        <xh-filter-layout title="方案分类" :leftVisible="true">
            <template slot="left">
                <el-tree class="filter-tree" node-key="id" :data="data" default-expand-all :expand-on-click-node="false" ref="tree" @node-click="treeClick" highlight-current></el-tree>
            </template>
            <template slot="filter">
                <el-form :inline="true" size="medium">
                    <el-form-item>
                        <el-button type="primary" @click="query" icon="el-icon-search">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="el-icon-plus" type="primary" @click="edit(null)">添加</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template #content>
                <MyTable ref="mytable" :url="table.url" :params="form" :method="table.method" stripe border fit :customSort="true">
                    <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                    <el-table-column prop="parent_name" label="父级" align="center"></el-table-column>
                    <el-table-column prop="business_name" label="名称" align="center"></el-table-column>
                    <el-table-column prop="sort" label="排序" align="center" width="60"></el-table-column>
                    <el-table-column label="操作" align="center" width="100">
                        <template slot-scope="scope">
                            <el-tooltip effect="dark" content="修改" placement="top">
                                <el-button circle type="warning" icon="el-icon-edit" size="mini" @click="edit(scope.row)"></el-button>
                            </el-tooltip>
                            <el-tooltip effect="dark" content="删除" placement="top">
                                <el-button circle type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)"></el-button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </MyTable>
            </template>
    </xh-filter-layout>
    <xh-dialog :title="dialog.title" :visible.sync="dialog.visible" width="55%" height="70%" :close-on-click-modal="false" @closed="closeModal">
        <SolutionTypeEdit ref="editRef" v-if="dialog.visible" :data="dialog.editRow" @closeModal="closeModal" center></SolutionTypeEdit>
    </xh-dialog>
    </div>
</template>
<script>
import XhFilterLayout from "@/components/XhComponents/XhFilterLayout";
import MyPanel from "@/components/Pannel/Pannel";
import MyTable from "@/components/XhComponents/XhPageTable";
import SolutionTypeEdit from "./components/SolutionTypeEdit";
export default {
    components: { XhFilterLayout, MyPanel, MyTable, SolutionTypeEdit },
    data() {
        return {
            title: 'GloriousHistory',
            form: {
                treePath: "",
                level: 3,
                businessType: "解决方案"
            },
            table: {
                method: "POST",
                url: "/Business/getData",
                pageSize: 50,
            },
            dialog: {
                title: "添加",
                visible: false,
                editRow: {}
            },
            data: [],
            id: "0",
            name: "顶级",
            treePath: "0",
            level: "0"
        }
    },
    methods: {
        query() {
            this.$refs.mytable.reload();
        },
        edit(row) {
            let that = this;
            if (row == null) {
                if (parseInt(that.level) > 2) {
                    that.$message.error("最多只能3级");
                    return false;
                }
                that.dialog.title = "添加";
                that.dialog.editRow = {
                    id: that.$util.guid(),
                    business_name: "",
                    parent_id: that.id,
                    parent_name: that.name,
                    business_type: "解决方案",
                    tree_path: that.treePath,
                    level: that.level,
                    is_show_index: 0,
                    sort: 1
                };
            } else {
                that.dialog.title = "修改";
                that.dialog.editRow = row;
            }

            that.dialog.visible = true;
        },
        //关闭弹出页面
        closeModal() {
            this.dialog.visible = false;
            this.$nextTick(function () {
                this.query();
                this.getDataTree();
            });
        },
        deleteRow(row) {
            let that = this;
            that.$confirm("删除后无法恢复, 确定要删除吗?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning" })
                .then(() => {
                    that.$api.post("/Business/deleteData", { id: row.id },
                        function (res) {
                            if (res.code === "200") {
                                that.query();
                                that.getDataTree();
                                that.$message.success("删除成功");
                            } else {
                                that.$message.error("删除失败");
                            }
                        },
                        function (res) {
                            //that.$message.error("服务器异常，删除出错");
                        }
                    );
                })
                .catch(() => {
                });

        },
        getDataTree() {
            let that = this;
            that.$api.post("/Business/getDataTree", { businessType: "解决方案" },
                function (res) {
                    that.data = [];
                    if (res.code === "200") {
                        that.data = [{ id: 0, label: '全部', children: res.data, code: "0", treePath: "0" }];
                    }
                    that.$nextTick(() => {
                        that.$refs.tree.setCurrentKey(that.id);
                    });
                },
                function (res) {
                    //that.$message.error("服务器异常，删除出错");
                }
            );
        },
        //树点击事件
        treeClick(obj, node, com) {
            this.id = obj.id;
            this.name = obj.label;
            this.treePath = obj.treePath;
            this.level = obj.code;
            this.form.treePath = this.treePath;
            this.query();
        },
    },
    computed: {},
    mounted() { },
    created() { this.getDataTree(); },
    watch: {},
}
</script>
<style scoped>
    /deep/.left-content {
        overflow-y: auto;
    }
</style>